export enum TimeBase {
  ByTime = 'BY_TIME',
  ByTrip = 'BY_TRIP'
}

export enum RentType {
  RentCar = 'RENT_CAR',
  RentCarWithDriver = 'RENT_CAR_WITH_DRIVER'
}
